import { render, staticRenderFns } from "./BrandingPage.vue?vue&type=template&id=31d9e1c1&scoped=true&"
import script from "./BrandingPage.vue?vue&type=script&lang=js&"
export * from "./BrandingPage.vue?vue&type=script&lang=js&"
import style0 from "./BrandingPage.vue?vue&type=style&index=0&id=31d9e1c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9e1c1",
  null
  
)

export default component.exports